<script>
     import {  Row  } from '@sveltestrap/sveltestrap';
     import { each } from 'svelte/internal';
     export let TN;

</script>

     <div class='row'>
          
               {#if TN.points=='-'}
                    <div style="margin-left: 35px; font-style: italic;text-decoration: line-through;font-size:0.8em">          
                         {TN.nom} - non joué
                    </div>
               {:else}
                    {#if TN.min}
                         <div style="margin-left: 35px;font-size:0.8em;background-color: grey;">
                              {TN.nom} - {TN.points.toFixed(4)}        
                         </div>     
                    {:else}    
                         <div style="margin-left: 35px;font-size:0.8em">
                              {TN.nom} - {TN.points.toFixed(4)}        
                         </div>    
                    {/if}
               {/if}
                    
     </div>


 <style>

     .row {
          height: 1em;
     }
 </style>